export const Header_Laptop = "/assets/png/header_laptop.webp";
export const Header_Phone = "/assets/png/header_phone.webp";
export const ChooseInvoice = "/assets/png/chooseInvoice.webp";
export const BusinessesWork = "/assets/png/businessesWork.webp";
export const EmployeeWork = "/assets/png/employeesWork.webp";
export const ImgFile = '/assets/svg/invozio-logo.svg';
export const DiscoverImage = '/assets/png/discover-invozio.webp';
export const InvoiceMobileWatch = "/assets/png/invoicemobile.webp";
export const officeImage = "/assets/png/office.webp";
export const country = "/assets/png/hong-kong.webp";
export const sppcolorimage = '/assets/png/spp-color-logo.png';
export const InvozioAsFreelancer = '/assets/png/invozio-help-as-a-freelancer.webp';
export const FreelanceLifePageLaptop = '/assets/png/freelance-life-page-laptop.webp';
export const FreelanceLifePageMan = '/assets/png/freelance-life-page-man.webp';
export const newsCard1 = '/assets/png/newscard1.webp';
export const newsCard2 = '/assets/png/newscard2.webp';
export const newsCard3 = '/assets/png/newscard3.webp';
export const newsCard4 = '/assets/png/newscard4.webp';
export const newsCard5 = '/assets/png/newscard5.webp';
export const newsCard6 = '/assets/png/newscard6.webp';
export const newsCard7 = '/assets/png/newscard7.webp';
export const newsCard8 = '/assets/png/newscard8.webp';
export const newsCard9 = '/assets/png/newscard9.webp';
export const Search = '/assets/svg/search.svg';
export const bookkeepingImage = '/assets/png/bookkeeping-hero-image.webp';
export const StartupSectionImage = '/assets/png/startup-section-image.webp';
export const FreelancerGetStarted = '/assets/png/Freelancer-get-started-hero-image.webp';
export const ManageSectionImage = '/assets/png/manage-section-hero-image.webp';
export const GuideIntroImage = '/assets/png/freelancing-guide-hero.webp';
export const BenefitsHeroImage = '/assets/png/benefits-hero-image.webp';
export const ChallengesHeroImage = '/assets/png/challenges-hero-image.webp';
export const TipsHeroImage = '/assets/png/tip-hero-image.webp';
export const Bullseye = '/assets/svg/bullseye.svg';
export const Chat = '/assets/svg/chat.svg';
export const Consultant = '/assets/svg/consultant.svg';
export const Development = '/assets/svg/development.svg';
export const Editing = '/assets/svg/editing.svg';
export const Marketing = '/assets/svg/marketing.svg';
export const Translation = '/assets/svg/translate.svg';
export const Writing = '/assets/svg/writing.svg';
export const Coins = '/assets/svg/coins.svg';
export const Feather = '/assets/svg/feather.svg';
export const Gift = '/assets/svg/gift.svg';
export const Like = '/assets/svg/like.svg';
export const NeutralEmoji = '/assets/svg/neutral-emoji.svg';
export const CreateAccountHeroImage = '/assets/png/create-account-hero-image.webp';
export const ambasadorBrand = '/assets/png/ambassdor-brand-image.webp'
export const ambasadorBrandTalk = '/assets/png/brand-ambassdor-talk-img.webp'
export const LandingPopup = '/assets/png/pop-up-image.webp'
export const LandingPopupMobile = '/assets/png/landing-pop-mobile.webp'
export const EnglishFlag = '/assets/png/eng-flag.png'
export const SwedishFlag = '/assets/png/swedish-flag.jpg'